import ApiRequest from "../axiosInstance/request";
import { endpoints } from "../endpoints";

export const fetchAboutUs = async () => {
  try {
    const res = await ApiRequest.get(endpoints.cms.about);
    return res;
  } catch (error) {
    return error;
  }
};

// Faq
export const faqQuery = () => {
  try {
    const res = ApiRequest.get(endpoints.cms.faq);

    return res;
  } catch (error) {
    return error;
  }
};

export const userDeatils = () => {
  try {
    const res = ApiRequest.get(endpoints.cms.faq);

    return res;
  } catch (error) {
    return error;
  }
};

export const submissionsList = (body) => {
  console.warn("🚀 ~ file: cms.api.js:24 ~ submissionsList ~ body:", body);
  return new Promise((resolve, reject) => {
    ApiRequest.post(endpoints.cms.submissions, body)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const qcSubmissionsList = (body) => {
  // console.warn("call qc list");s
  return new Promise((resolve, reject) => {
    ApiRequest.post(endpoints.QC.submissions, body)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const customSubmissionsList = (body, queryParams) => {
  const { startDate: from, endDate: to } = queryParams;
  console.warn("customSubmissionsList", from, to);
  return new Promise((resolve, reject) => {
    ApiRequest.post(
      endpoints.cms.submissions,

      { ...body, from, to }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
